const CARDS = [
  {
    title: '娱乐圈潜规则大揭秘：你不知道的那些事',
    desc: '深度调查娱乐圈不为人知的运作规则，从选角到宣传的全链条揭秘。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20backstage%20theater%20area%20with%20dramatic%20spotlight%20shadows%2C%20velvet%20curtains%2C%20warm%20golden%20and%20coral%20lighting%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20no%20people&width=500&height=320&seq=cards-01-2026&orientation=landscape',
    tag: '深度',
  },
  {
    title: '从素人到网红：流量时代的造星产业链',
    desc: '拆解MCN机构的运作模式，揭秘网红是如何被批量制造和变现的。',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20content%20creation%20studio%20with%20ring%20lights%20and%20cameras%2C%20social%20media%20screens%2C%20warm%20creative%20workspace%2C%20contemporary%20digital%20aesthetic%2C%20editorial%20style%2C%20no%20people&width=500&height=320&seq=cards-02-2026&orientation=landscape',
    tag: '揭秘',
  },
  {
    title: '那些年我们一起追过的塌房名场面',
    desc: '回顾近年最经典的网红明星塌房事件，每一次都让人记忆犹新。',
    img: 'https://readdy.ai/api/search-image?query=A%20collapsing%20house%20of%20cards%20made%20of%20social%20media%20icons%2C%20dramatic%20lighting%20with%20warm%20and%20teal%20contrast%2C%20conceptual%203D%20illustration%2C%20clean%20minimal%20background%2C%20editorial%20art%20style&width=500&height=320&seq=cards-03-2026&orientation=landscape',
    tag: '回顾',
  },
  {
    title: '综艺节目剪辑的奥秘：你看到的都是设计好的',
    desc: '资深综艺导演揭秘剪辑套路，矛盾冲突都是这样制造出来的。',
    img: 'https://readdy.ai/api/search-image?query=A%20professional%20video%20editing%20suite%20with%20multiple%20monitors%20showing%20colorful%20timelines%2C%20warm%20ambient%20lighting%2C%20creative%20post%20production%20environment%2C%20editorial%20photography%2C%20no%20people&width=500&height=320&seq=cards-04-2026&orientation=landscape',
    tag: '内幕',
  },
  {
    title: '吃瓜经济学：一条八卦值多少钱？',
    desc: '从狗仔队到营销号，八卦产业链背后的惊人商业价值分析。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20floating%20golden%20coins%20and%20newspaper%20headlines%2C%20warm%20coral%20and%20gold%20color%20scheme%2C%20financial%20concept%20art%2C%20modern%20minimal%20design%2C%20editorial%20style%2C%20no%20text%20no%20people&width=500&height=320&seq=cards-05-2026&orientation=landscape',
    tag: '分析',
  },
  {
    title: '海外吃瓜文化差异：各国网友都在八卦什么',
    desc: '对比中美日韩吃瓜文化的异同，看看不同国家网友的八卦口味。',
    img: 'https://readdy.ai/api/search-image?query=A%20world%20map%20made%20of%20colorful%20speech%20bubbles%20in%20different%20languages%2C%20warm%20global%20communication%20concept%2C%20teal%20and%20coral%20accents%2C%20modern%20flat%20illustration%20style%2C%20editorial%20design%2C%20no%20text&width=500&height=320&seq=cards-06-2026&orientation=landscape',
    tag: '趣闻',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            深度吃瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            51吃瓜网精选深度好文，不止于吃瓜，更要看懂瓜背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CARDS.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-semibold bg-accent-500 text-white px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}